import { Fragment } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Dialog, DialogPanel, Transition } from "@headlessui/react";
import { classNames } from "../../helpers/classNames";
import Button from "../form/Button";

const Modal = ({
  title,
  subtitle,
  children,
  isOpen = false,
  setIsOpen = () => {},
  size = "xl4",
  modalDialogueStyle = "",
  modalBodyClass = "",
  header = true,
  isClose = true,
  bodyClasses,
  isOutsideClose = true,
  titleClass,
  headerClass,
}) => {
  const modalSize = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    xl2: "sm:max-w-2xl",
    xl3: "sm:max-w-3xl",
    xl4: "sm:max-w-4xl",
    xl5: "sm:max-w-5xl",
    xl6: "sm:max-w-6xl",
    xl7: "sm:max-w-7xl",
    xl8: "sm:max-w-8xl",
    xl9: "sm:max-w-9xl",
    full: "max-w-full",
  };

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <Dialog
            as="div"
            className="relative z-90"
            open={isOpen}
            onClose={isOutsideClose ? () => setIsOpen(false) : () => {}}
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 flex items-center justify-center"
            />
            <div className="fixed inset-0 w-screen overflow-y-auto p-4">
              <div className="flex min-h-full items-center justify-center">
                <DialogPanel
                  as={motion.div}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  className={classNames(
                    `w-full ${modalSize[size]} transform text-left align-middle shadow-xl transition-all`,
                    modalBodyClass
                  )}
                >
                  <div
                    className={classNames(
                      "rounded-2xl bg-white relative",
                      modalDialogueStyle
                    )}
                  >
                    {header && (
                      <div
                        className={classNames(
                          "relative py-4 px-10 flex justify-between border-b border-shades-03 bg-chestnut-rose/10",
                          headerClass
                        )}
                      >
                        <div className="flex-shrink text-center w-full">
                          <h2
                            className={`text-xl tracking-tight font-semibold text-gable-green ${
                              titleClass ? titleClass : ""
                            }`}
                          >
                            {title}
                          </h2>
                          <div className="text-sm font-medium text-shades-07">
                            {subtitle}
                          </div>
                        </div>
                        {isClose && (
                          <div className="absolute -top-[6px] -right-[3px]">
                            <Button
                              buttonIcon={"fa-regular fa-xmark"}
                              buttonIconPosition={"left"}
                              buttonClasses={
                                "!w-9 !h-9 !p-0 !justify-center !text-xl !bg-chestnut-rose !border !text-shades-07 hover:!bg-shades-03 hover:rotate-90 transition-all duration-300 !text-white hover:!text-chestnut-rose !rounded-full"
                              }
                              buttonFunction={() => setIsOpen(false)}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {!header && isClose && (
                      <div className="absolute -top-4 -right-4 z-10">
                        <Button
                          buttonIcon={"fa-regular fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonClasses={
                            "!w-9 !h-9 !p-0 !justify-center !rounded-full !text-xl !bg-white !border !text-shades-07 hover:!bg-shades-03 hover:rotate-90 transition-all duration-150 ease-out"
                          }
                          buttonFunction={() => setIsOpen(false)}
                        />
                      </div>
                    )}
                    <div
                      className={classNames("relative py-4 px-10", bodyClasses)}
                    >
                      {children}
                    </div>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        )}
      </AnimatePresence>
    </>
  );
};

export default Modal;
